document.addEventListener("DOMContentLoaded", function(){
    syncResources();
    reviewsInit();

    // if(document.querySelector("body").classList.contains("template-product") && document.querySelector(".hengam-product-price-wrapper")) {
    //   setTimeout(() => {
    //     if(document.querySelector(".product-details > div.group-block > .group-block-content > div:nth-child(2) > .group-block-content product-price > div .price").hasAttribute("style")) {
    //       document.querySelector(".product-details > div.group-block > .group-block-content > div:nth-child(2) > .group-block-content product-price > div .price").removeAttribute("style");
    //     }
    //   }, 1200)
    // }
});

(function() {
  const origDispatch = document.dispatchEvent;
  document.dispatchEvent = function(e) {
    console.log("Event fired:", e.type, e);
    return origDispatch.call(this, e);
  };
})();

function syncResources() {
    const resourcesNav = document.querySelector(".resources-nav");
    const allResources = resourcesNav?.querySelectorAll(".section-content-wrapper a");

    if(!resourcesNav) return;

    const currentPath = window.location.pathname;
    allResources.forEach(link => {
        // Normalize trailing slashes to avoid mismatch
        const linkPath = new URL(link.href).pathname.replace(/\/$/, '');
        const pathToCompare = currentPath.replace(/\/$/, '');

        if (linkPath === pathToCompare) {
            link.setAttribute('aria-disabled', 'true');
            link.classList.add('is-active'); // optional styling hook
            link.style.pointerEvents = 'none'; // prevent clicks
        } else {
            link.removeAttribute('aria-disabled');
            link.classList.remove('is-active');
            link.style.pointerEvents = '';
        }
    });
    
}

function reviewsInit() {
  const isProduct = document.body.classList.contains("template-product");
  if (!isProduct) return;

  const target = document.body;

  const observer = new MutationObserver(() => {
    const averageNode = document.querySelector(".jdgm-rev-widg__summary-average");
    const container = document.querySelector(".jdgm-rev-widg__summary-inner");
    const textContainer = document.querySelector(".jdgm-rev-widg__summary-average");
    const reviewsTab = document.querySelector(".jdgm-subtab__name[data-tabname='reviews'] .jdgm-subtab__count");
    const questionsTab = document.querySelector(".jdgm-subtab__name[data-tabname='questions'] .jdgm-subtab__count");

    if (averageNode && container && !document.querySelector(".custom-average-rating") && textContainer && reviewsTab && questionsTab) {
      const avg = document.createElement("div");
      avg.className = "custom-average-rating";
      avg.innerText = averageNode.innerText;
      container.prepend(avg);

      var reviewsQuestionsCount = document.querySelector(".jdgm-subtab__name[data-tabname='reviews'] .jdgm-subtab__count").innerText;
      reviewsQuestionsCount = reviewsQuestionsCount == '1' ? '1 Review, ' : reviewsQuestionsCount + 'Reviews, ';
      reviewsQuestionsCount += document.querySelector(".jdgm-subtab__name[data-tabname='questions'] .jdgm-subtab__count").innerText == '1' ? '1 Q&A' : document.querySelector(".jdgm-subtab__name[data-tabname='questions'] .jdgm-subtab__count").innerText + 'Q&As';
      textContainer.innerText = reviewsQuestionsCount;

      document.querySelectorAll(".jdgm-rev-widg__reviews .jdgm-rev").forEach(review => {
        review.querySelector(".jdgm-rev__title").after(review.querySelector(".jdgm-row-profile"));
      });

      observer.disconnect(); // Stop watching once done
    }
  });

  observer.observe(target, {
    childList: true,
    subtree: true
  });
}